import styled from "styled-components";

export const RadioChannels = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (max-width: 899px) {
    margin-top: 18px;
  }

  @media (max-width: 1400px) {
    grid-column: 1 / 3;
  }
`;
